import { DeepLinkParams, RequestDetails } from './RisCommonInterfaces';
import {
  AbConfigKeyMappings,
  getPokusConfig,
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import RailsModule from '@mmt/legacy-commons/Native/RailsModule';
import { Actions } from '../../navigation';
import { Platform } from 'react-native';
import { getDateDetails } from 'apps/rails/src/Utils/RisUtils';
import fecha from 'fecha';
import GenericModule from '@mmt/core/native/GenericModule';
import BusSharedModuleHolder from '@mmt/bus-shared/src';
import {
  SearchParams,
  CrossSellTypes,
  CROSS_SELL_TYPES,
} from 'apps/rails/src/pages/RIS/PnrStatus/Components/PNRCrossSells/types';
import { BUS_DEEPLINK, RAILS_DEEPLINK } from 'apps/rails/src/Utils/RailsConstant';
import { StoppingStation } from './LiveTrainStatus/interface';

export const openLiveTrainStatus = async (requestDetails: RequestDetails) => {
  const { trainDetails, stationDetails, dateDetails } = requestDetails;
        Actions.railLiveTrainStatusRNLanding({
          requestDetails: {
            trainDetail: trainDetails,
            stationDetail: stationDetails,
            dateDetail: dateDetails,
          },
        });
};

export const openLiveTrainStatusFromDeeplink = async (deepLinkParams: DeepLinkParams) => {
  const dateOfJourney = fecha.parse(deepLinkParams.dateOfJourney, 'YYYYMMDD');
  const dateDetail = getDateDetails(dateOfJourney);
  Actions.railLiveTrainStatusRNLanding({
    requestDetails: {
      trainDetail: {
        trainNumber: deepLinkParams?.trainNumber,
      },
      dateDetail,
    },
  });
};

export const getRailsListingDeeplinkFromPnrDetails = (pnrDetails: any, isReturnTicket: boolean) => {
  const {
    PnrDetails,
    TrainDetails,
    CityDetails: { SourceCity, DestinationCity } = {},
  } = pnrDetails;
  const startCode = isReturnTicket ? DestinationCity?.Code : SourceCity?.Code;
  const endCode = isReturnTicket ? SourceCity?.Code : DestinationCity?.Code;
  const journeyDate = isReturnTicket
    ? SourceCity?.Code
    : TrainDetails?.TrainStartingDate?.replaceAll('-', '');
  return RAILS_DEEPLINK.LISTING.replace('{startCode}', startCode)
    .replace('{endCode}', endCode)
    .replace('{journeyDate}', journeyDate)
    .replace('pnr', PnrDetails.Pnr)
    .replace('alternate', 'true');
};

export const getRailsListingDeeplinkFromLtsDetails = (
  SourceCity: StoppingStation,
  DestinationCity: StoppingStation,
  returnDate: string,
) => {
  const startCode = SourceCity?.Station.code;
  const endCode = DestinationCity?.Station.code;
  const journeyDate = returnDate?.replaceAll('-', '');
  return RAILS_DEEPLINK.LISTING_FROM_LTS.replace('{startCode}', startCode)
    .replace('{endCode}', endCode)
    .replace('{journeyDate}', journeyDate);
};

export const getDateForReturnTicket = (date: string): Date | null => {
  try {
    return fecha.parse(date, 'YYYYMMDD');
  } catch (error) {
    return null;
  }
};

export const openCrossSell = (
  searchParams: SearchParams,
  type: CrossSellTypes,
  journeyDate: Date | null = null,
) => {
  const { date, destinationName, destinationCode, sourceName, sourceCode } = searchParams;
  const listingDate = journeyDate || date;
  if (type === CROSS_SELL_TYPES.BUS) {
    if(Platform.OS === 'web'){
      const busListingUrl = BUS_DEEPLINK.LISTING_WEB
        .replace('${fromName}', sourceName)
        .replace('${fromCode}', sourceCode)
        .replace('${toName}', destinationName)
        .replace('${toCode}', destinationCode)
        .replace('${dateStr}', fecha.format(listingDate, 'YYYY-MM-DD'));
        window.location.href = busListingUrl;
      return;
    }
    const busSharedResourceProvider = BusSharedModuleHolder.get();
    if (!busSharedResourceProvider || !listingDate) {
      return;
    }
    const navigation = busSharedResourceProvider.getBusSharedNavigation();
    const obj = {
      from: sourceName,
      to: destinationName,
      departureDate: listingDate,
      from_code: sourceCode,
      to_code: destinationCode,
      source: 'RISxSell',
    };
    navigation.openBusListing(obj);
    return;
  }

  const originStation = {
    cityName: sourceName,
    code: sourceCode,
  };
  const destinationStation = {
    cityName: destinationName,
    code: destinationCode,
  };
  if (type === CROSS_SELL_TYPES.RETURN_TICKETS && journeyDate == null) {
    listingDate.setDate(listingDate.getDate() + 3);
  }

  Actions.railsListing({
    originStation,
    destinationStation,
    departureDate: listingDate,
    source: 'PNR',
  });
};

export const openTravellerPage = (
  frmStnCode: any,
  toStnCode: any,
  travelDate: any,
  trainNumber: any,
  classType: any,
  quota: any,
  frmStnName: any,
  toStnName: any,
  Pnr: any,
) => {
  const travellerDeepLink = RAILS_DEEPLINK.TRAVELLER.replace('{frmStnCode}', frmStnCode)
    .replace('{toStnCode}', toStnCode)
    .replace('{travelDate}', travelDate)
    .replace('{trainNumber}', trainNumber)
    .replace('{classType}', classType)
    .replace('{quota}', quota)
    .replace('{alternate}', 'true')
    .replace('{boardingStationCode}', frmStnCode)
    .replace('{destStationCode}', toStnCode)
    .replace('{frmStnName}', frmStnName)
    .replace('{toStnName}', toStnName)
    .replace('{pnr}', Pnr);
  GenericModule.openDeepLink(travellerDeepLink);
};
